/**
 * CleanViewButton — hides the full-canvas viewer chrome so the active camera
 * or map can use the viewport without the event and camera cards covering it.
 *
 * The control stays mounted inside `player_overlay`, so the same icon restores
 * the chrome. This is intentionally separate from native fullscreen: it works
 * at every breakpoint and in embedded browsers where the Fullscreen API may be
 * unavailable.
 */

import { useRef, useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { registerPrimitive } from '../../layout'

export function CleanViewButton() {
  const ref = useRef<HTMLButtonElement | null>(null)
  const [cleanView, setCleanView] = useState(false)
  const label = cleanView ? 'Show overlays' : 'Hide overlays'
  const Icon = cleanView ? Eye : EyeOff

  return (
    <button
      ref={ref}
      type="button"
      className="lv-player-ctrl"
      aria-label={label}
      aria-pressed={cleanView}
      title={label}
      onClick={(event) => {
        event.stopPropagation()
        const shell = ref.current?.closest('.lv-canvas-shell')
        if (!shell) return

        const next = !shell.classList.contains('lv-clean-view')
        shell.classList.toggle('lv-clean-view', next)
        setCleanView(next)
      }}
    >
      <Icon size={16} strokeWidth={2} aria-hidden="true" />
    </button>
  )
}

registerPrimitive('CleanViewButton', CleanViewButton)
